function About() {
    const appStoreUrl = "https://apps.apple.com/app/6737629704";
    
    return (
      <div style={styles.container}>
        <div style={styles.hero}>
          <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
            <img 
              src="./Assets/Images/logoDownloadFull.png" 
              alt="Day By Data"
              style={styles.logo}
            />
          </a>
          <h1 style={styles.title}>Day By Data</h1>
          <p style={styles.tagline}>
            Turn your Apple Health and Spotify data into beautiful visualizations and art
          </p>
          <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
            <img 
              src="./Assets/Images/downloadWhite.svg" 
              alt="Download on App Store" 
              style={styles.appStoreDownload}
            />
          </a>
        </div>
  
        <div style={styles.content}>
          <div style={styles.section}>
            <div style={styles.textContent}>
              <h2 style={styles.sectionTitle}>Overview</h2>
              <p style={styles.description}>
                Get a comprehensive view of your daily activities and habits through 
                beautiful visualizations. Day By Data presents your data across several different visualizations and art pieces.
              </p>
            </div>
            <a href={appStoreUrl} target="_blank" rel="noopener noreferrer" style={styles.imageLink}>
              <div style={styles.imageContainer}>
                <img 
                  src="./Assets/Images/Overview Screen.jpg" 
                  alt="Overview Screen" 
                  style={styles.appImage}
                />
              </div>
            </a>
          </div>

          <div style={styles.section}>
            <div style={styles.imageContainer}>
              <img 
                src="./Assets/Images/Receipt Preview.jpg" 
                alt="Receipt View" 
                style={styles.appImage}
              />
            </div>
            <div style={styles.textContent}>
              <h2 style={styles.sectionTitle}>Daily Receipts</h2>
              <p style={styles.description}>
                Get detailed breakdowns of your daily steps in a unique receipt format.
                A creative way to review and reflect on your day, month, year, and all-time data logged.
              </p>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.textContent}>
              <h2 style={styles.sectionTitle}>A Snapshot of your Spotify Data</h2>
              <p style={styles.description}>
                Capture your latest and all-time top songs, artists, genres, and other stats like tempo, energy, and danceability.
              </p>
            </div>
            <div style={styles.imageContainer}>
              <img 
                src="./Assets/Images/Snapped Preview.jpg" 
                alt="Snapped Preview" 
                style={styles.appImage}
              />
            </div>
          </div>
  
  
          <div style={styles.section}>
            <div style={styles.imageContainer}>
              <img 
                src="./Assets/Images/Milestones Preview.jpg" 
                alt="Milestones View" 
                style={styles.appImage}
              />
            </div>
            <div style={styles.textContent}>
              <h2 style={styles.sectionTitle}>Track Your Milestones</h2>
              <p style={styles.description}>
                Celebrate your achievements and track your progress over time. 
                Each milestone is a testament to your journey and commitment.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  const styles = {
    container: {
      width: '100%',
      minHeight: '100vh',
      backgroundColor: '#fffef7',
      fontFamily: '"Bodoni Moda", serif',
    },
    hero: {
      padding: '4rem 2rem',
      textAlign: 'center',
      borderBottom: '1px solid #eaeaea',
    },
    logo: {
      width: '180px',
      height: 'auto',
      marginBottom: '2rem',
    },
    title: {
      fontSize: '3.5rem',
      fontWeight: '700',
      color: '#0a0a0a',
      marginBottom: '1rem',
    },
    tagline: {
      fontSize: '1.5rem',
      color: '#0a0a0a',
      maxWidth: '800px',
      margin: '0 auto',
      lineHeight: '1.6',
    },
    content: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '4rem 2rem',
    },
    section: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '4rem',
      marginBottom: '6rem',
      '@media (maxWidth: 768px)': {
        flexDirection: 'column',
        textAlign: 'center',
      },
    },
    textContent: {
      flex: 1,
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: '600',
      color: '#0a0a0a',
      marginBottom: '1.5rem',
    },
    description: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      color: '#0a0a0a',
    },
    imageContainer: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    appImage: {
      maxWidth: '100%',
      height: 'auto',
      borderRadius: '12px',
      boxShadow: '0 20px 40px rgba(0,0,0,0.05)',
    },
    appStoreDownload: {
      width: '200px',
      height: 'auto',
      marginTop: '2rem',
    },
    imageLink: {
        flex: 1,
        textDecoration: 'none',
        cursor: 'pointer',
    },
  };
  
  export default About;